import axios from "axios";
export const API_URL = "/api/v1";
export const GET_DASHBOARD_DATA_URL = API_URL+"/dashboard/get_dashboard_data/";
export const GET_TREATMENT_DASHBOARD_DATA_URL = API_URL+"/dashboard/get_treatment_dashboard_data/";
export const GET_CAR_STATE_URL = API_URL+"/dashboard/get_car_state_list/";
export const GET_WASTEVERSE_BAR_STATE_URL = API_URL+"/dashboard/get_wasteverse_bar_state_list/";
export const GET_TOP_DATA_URL = API_URL+"/dashboard/get_top_data/";
export const GET_SUMMARY_TOP_DATA_URL = API_URL+"/dashboard/get_summary_top_data/";
export const GET_COLLECT_DASHBOARD_DATA_URL = API_URL+"/dashboard/get_collect_dashboard_data/";
export const GET_COLLECT_PAYMENT_DASHBOARD_DATA_URL = API_URL+"/dashboard/get_collect_payment_dashboard_data/";

export function getDashBoardData() {
  return axios.get(GET_DASHBOARD_DATA_URL);
}

export function getTreatmentDashBoardData() {
  return axios.get(GET_TREATMENT_DASHBOARD_DATA_URL);
}

export function getCarState() {
  return axios.get(GET_CAR_STATE_URL);
}

export function getWasteverseBarState() {
  return axios.get(GET_WASTEVERSE_BAR_STATE_URL);
}

export function getTopData() {
  return axios.get(GET_TOP_DATA_URL);
}

export function getSummaryTopData() {
  return axios.get(GET_SUMMARY_TOP_DATA_URL);
}

export function getCollectDashboardData() {
  return axios.get(GET_COLLECT_DASHBOARD_DATA_URL);
}

export function getCollectPaymentDashboardData() {
  return axios.get(GET_COLLECT_PAYMENT_DASHBOARD_DATA_URL);
}
